<template>
  <div class="py-16 lg:py-24">
    <div class="bg-gradient-to-r from-pink-400 to-pink-500 rounded-lg shadow-xl overflow-hidden md:grid md:grid-cols-2 md:gap-4">
      <div class="pt-10 pb-12 px-6 sm:pt-16 sm:pl-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
        <div class="lg:self-center">
          <h2 class="text-3xl font-extrabold text-white sm:text-4xl">
            <span class="block">This is when you</span>
            <span class="block text-red-900">YOLO in ;)</span>
          </h2>
          <p class="mt-4 text-lg leading-6 text-pink-50">
            We'd love to have you at the Diamond Hands Hotel. Contact us for more information or to get started.
          </p>
          <a href="mailto:apply@diamondhandshotel.com" class="mt-8 bg-pink-100 border border-transparent rounded-md shadow py-3 px-6 inline-flex items-center text-base font-medium text-red-600 hover:text-red-500">
            Apply now
          </a>
        </div>
      </div>
      <div class="-mt-6 aspect-w-6 aspect-h-3 md:aspect-w-3 md:aspect-h-2 pointer-events-none">
        <img class="transform rounded-md object-cover -object-top-4 sm:translate-y-3 lg:-translate-x-2" src="@/assets/img/sss/6.png" alt="App screenshot">
      </div>
    </div>
  </div>
</template>